var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDisableTagsManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M33.16 19.13L19.58 5.55A1.92 1.92 0 0018.21 5h-2.09l15.63 15.45-10.53 10.62a1.93 1.93 0 002.73 0l9.21-9.21a1.93 1.93 0 000-2.73z",
    className: "icon_disable_tags_management_svg__clr-i-solid icon_disable_tags_management_svg__clr-i-solid-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M27.78 19.17L14.2 5.58A1.92 1.92 0 0012.83 5H3.61a1.93 1.93 0 00-1.93 1.93v9.22a1.92 1.92 0 00.57 1.36L15.84 31.1a1.93 1.93 0 002.73 0l9.21-9.21a1.93 1.93 0 000-2.72zM6.67 11.72A1.73 1.73 0 118.4 10a1.73 1.73 0 01-1.73 1.72z",
    className: "icon_disable_tags_management_svg__clr-i-solid icon_disable_tags_management_svg__clr-i-solid-path-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}

export default SvgIconDisableTagsManagement;